import React from 'react';
import { Translate } from 'react-redux-i18n';

import { TemplatePage } from '../../../../components/common/pager';
import { TemplateHeader } from '../../../../components/template/templateHeader';
import TemplateViewContainer from '../../../../components/template/templateViewContainer';
import TemplateFormBuilderView from '../../../../components/template/templateFormBuilderView';
import SectionDetails from '../../../../components/vipProgram/SectionDetails';
import { SimpleProgressBar } from '../../../../components/common/SimpleProgressBar';
import { UrlWithCopy } from '../../../../components/common/UrlWithCopy';

import { PartOneInfo } from '../components/partOneInfo';
import ApplicantHistory from '../components/applicantHistory/ApplicantHistory';
import { Link } from 'react-router-dom';
import RegistrationFeeHistory from '../components/RegistrationFeeHistory';
import { tabs as accountTabs } from '../../../accounts/constants';
import {
  SystemOnlyIcon,
  SystemOnlyPopup
} from '../../../../components/common/SystemOnlyBadge';

import { paths } from '../constants/template';

import { I18n } from 'react-redux-i18n';
import { formatDateByCountry } from '../../../../helpers/dateAndTimeHelper';
import CurrencyHelper from '../../../../helpers/currencyHelper';
import { isFundraisingGuaranteeAvailable } from '../../helpers/fundraisingGuarantee';
import {
  getRegistrationFeeChargeKey,
  getRegistrationFeePaymentLabel
} from '../../constants';
import './applicationView.css';

export const getPartOneViewTab = (props) => {
  const {
    required,
    email,
    formBuilderAnswers,
    dateReceived,
    fundraiserRaisedAmount,
    fundraiserTargetAmount,
    fundraiserUrlFull,
    fundraiserId,
    fundraiserName,
    eventName,
    eventAmbassadorId,
    eventAmbassadorProgramName,
    isApplicationPartTwoVisible,
    hasDonationPlan,
    fundraiseBy,
    fundraiserMinimumTargetAmount,
    donationPlanChargedAmount,
    registrationFee,
    applicantStatus,
    organizationCountry,
    organizationCurrency,
    minimumTargetCurrency,
    firstName,
    lastName,
    emailAddress,
    accountId,
    organizationId,
    terms,
    isChangeLinkedPageModalOpen,
    onCloseChangeLinkedPageModal,
    organizationName,
    isSystemAdmin
  } = props;

  const guaranteeCurrency = minimumTargetCurrency || organizationCurrency;

  // The guarantee is never offered to a UK applicant, so the section has
  // nothing true to say for them.
  const showFundraisingGuarantee = isFundraisingGuaranteeAvailable(organizationCountry);

  const feeCharge = registrationFee?.charge;
  const feeChargeParams = feeCharge && {
    amount: CurrencyHelper.formatCurrency(feeCharge.amount, feeCharge.currency),
    date: formatDateByCountry(feeCharge.chargedAt, organizationCountry)
  };
  const registrationFeePaymentLabel = feeCharge
    ? I18n.t(
        `applications.template.page.partOne.registration-fee.${getRegistrationFeeChargeKey(feeCharge)}`,
        feeChargeParams
      )
    : registrationFee?.enabled && getRegistrationFeePaymentLabel(applicantStatus);
  const showRegistrationFee = registrationFee?.enabled;

  const fundraisingCommitmentTerms = terms.find(item => item.context === "customCampaignAmbassadorDonationPlanTerms");
  const registrationFeeTerms = terms.find(item => item.context === "registrationFeeTerms");

  return (
    <TemplatePage
      id="part-one"
      i18nKey={`${isApplicationPartTwoVisible
        ? 'applications.template.page.partOne.application-details-title'
        : 'applications.template.page.partOne.title'
        }`}
    >
      <TemplateHeader
        as="h2"
        label="applications.template.page.partOne.header-name.label"
      />

      <PartOneInfo
        dateReceived={dateReceived}
        fundraiserRaisedAmount={fundraiserRaisedAmount}
        fundraiserUrlFull={fundraiserUrlFull}
        fundraiserId={fundraiserId}
        fundraiserName={fundraiserName}
        eventName={eventName}
        eventAmbassadorId={eventAmbassadorId}
        eventAmbassadorProgramName={eventAmbassadorProgramName}
        isChangeLinkedPageModalOpen={isChangeLinkedPageModalOpen}
        onCloseChangeLinkedPageModal={onCloseChangeLinkedPageModal}
        organizationName={organizationName}
      />

      {fundraiserId && (
        <>
          <TemplateHeader
            as="h5"
            label="applications.template.page.partOne.fundraiser-details.label"
          />

          <div isolated className="template-view-container application-card">
            <div className="field field-section">
              <label>{I18n.t('applications.template.page.partOne.fundraiser-details.page-url')}</label>
              <div className="field-value">
                <UrlWithCopy url={fundraiserUrlFull} />
              </div>
            </div>

            <div className="field field-section">
              <label>{I18n.t('applications.template.page.partOne.fundraiser-details.progress')}</label>
              <div className="field-value">
                <SimpleProgressBar
                  value={fundraiserRaisedAmount || 0}
                  target={fundraiserTargetAmount || 0}
                  minimumTargetAmount={fundraiserMinimumTargetAmount}
                  currency={organizationCurrency}
                  color="green"
                  size="small"
                  showPercentage={true}
                />
              </div>
            </div>
          </div>
        </>
      )}

      <TemplateHeader
        as="h5"
        label="applications.template.page.partOne.account-details-name.label"
      />

      <SectionDetails
        fields={[
          {
            label: I18n.t('applications.template.page.partOne.first-name.label'),
            value: firstName || '',
            required: false
          },
          {
            label: I18n.t('applications.template.page.partOne.last-name.label'),
            value: lastName || '',
            required: false
          },
          {
            label: I18n.t('applications.template.page.partOne.email-name.label'),
            value: emailAddress || '',
            required: false
          }
        ]}
      />

      <ApplicantHistory
        accountId={accountId}
        organizationId={organizationId}
        currency={organizationCurrency}
      />

      <TemplateHeader
        as="h5"
        label="applications.template.page.partOne.event-questions-name.label"
      />

      <TemplateViewContainer
        className="application-card"
        path={paths.APPLICATION_ENTRY}
        validation={formBuilderAnswers}
      >
        <TemplateFormBuilderView path={paths.APPLICATION_ENTRY} />
      </TemplateViewContainer>

      <TemplateHeader
        as="h5"
        path={paths.OGRANIZATION_QUESTIONS_HEADER}
        label="applications.template.page.partOne.organization-questions-name.label"
      />

      <TemplateViewContainer
        className="application-card"
        path={paths.APPLICATION_ADDITIONAL}
        validation={formBuilderAnswers}
      >
        <TemplateFormBuilderView
          path={paths.APPLICATION_ADDITIONAL}
          validation={formBuilderAnswers}
        />
      </TemplateViewContainer>

      {showFundraisingGuarantee && (
        <>
          <TemplateHeader
            as="h5"
            path={paths.FUNDRAISING_GUARANTEE_HEADER}
            label="applications.template.page.partOne.fundraising-guarantee.label"
          />

          <SectionDetails
            fields={[
              {
                label: I18n.t('applications.template.page.partOne.fundraising-guarantee.card-on-file'),
                value: hasDonationPlan ? 'Yes' : 'No',
                required: false,
              },
              {
                label: I18n.t('applications.template.page.partOne.fundraising-guarantee.fundraise-by-locked-date'),
                value: formatDateByCountry(fundraiseBy, organizationCountry),
                required: false
              },
              {
                label: I18n.t('applications.template.page.partOne.fundraising-guarantee.minimum-fundraising-target-locked-amount'),
                value: `${CurrencyHelper.formatCurrency(fundraiserMinimumTargetAmount, guaranteeCurrency)} ${guaranteeCurrency || ''}`.trim(),
                required: false
              },
              ...((fundraisingCommitmentTerms && fundraisingCommitmentTerms.explicitlyAccepted)
                ? [{
                  label: I18n.t('applications.template.page.partOne.fundraising-guarantee.fundraising-commitment-agreement'),
                  value: "Accepted",
                  required: false
                }]
                : []
              ),
              ...(donationPlanChargedAmount
                ? [{
                  label: I18n.t('applications.template.page.partOne.fundraising-guarantee.charged-amount'),
                  value: `${CurrencyHelper.formatCurrency(donationPlanChargedAmount, guaranteeCurrency)} ${guaranteeCurrency || ''}`.trim(),
                  required: false
                }]
                : []
              ),
            ]}
          />
        </>
      )}

      {showRegistrationFee && (
        <>
          <TemplateHeader
            as="h5"
            label="applications.template.page.partOne.registration-fee.label"
          />

          <SectionDetails
            isolated
            fields={[
              ...(registrationFee?.amount != null
                ? [{
                  label: I18n.t('applications.template.page.partOne.registration-fee.amount'),
                  value: CurrencyHelper.formatCurrency(registrationFee.amount, registrationFee.currency),
                  required: false
                }]
                : []
              ),
              ...((registrationFeeTerms && registrationFeeTerms.explicitlyAccepted)
                ? [{
                  label: I18n.t('applications.template.page.partOne.registration-fee.agreement'),
                  value: (
                    <>
                      {I18n.t('applications.template.page.partOne.registration-fee.agreement-accepted')}
                      {isSystemAdmin && accountId != null && (
                        <>
                          {' - '}
                          <SystemOnlyPopup>
                            <Link to={`/accounts/detail/${accountId}/${accountTabs.CONSENT}`}>
                              {I18n.t('applications.template.page.partOne.registration-fee.view-consent')}
                              <SystemOnlyIcon />
                            </Link>
                          </SystemOnlyPopup>
                        </>
                      )}
                    </>
                  ),
                  required: false
                }]
                : []
              ),
              ...(registrationFeePaymentLabel
                ? [{
                  label: I18n.t('applications.template.page.partOne.registration-fee.payment'),
                  value: registrationFeePaymentLabel,
                  required: false
                }]
                : []
              )
            ]}
          >
            <RegistrationFeeHistory
              attempts={registrationFee?.charges}
              organizationCountry={organizationCountry}
            />
          </SectionDetails>
        </>
      )}

      <TemplateHeader
        as="h2"
        path={paths.PART_TWO_HEADER}
        label="applications.template.page.partOne.part-two-header.label"
      />

      <TemplateViewContainer
        className="application-card"
        path={paths.APPLICATION_CONFIRMATION}
        validation={formBuilderAnswers}
      >
        <TemplateFormBuilderView
          path={paths.APPLICATION_CONFIRMATION}
          validation={formBuilderAnswers}
        />
      </TemplateViewContainer>
    </TemplatePage>
  );
};
